export const PNL_REPORT_DATA = "PNL_REPORT_DATA";
export const PNL_SUMMARIZE = "PNL_SUMMARIZE";
export const LONG_TERM_QUANTITY = "LONG_TERM_QUANTITY";
export const PNL_SEARCH = "PNL_SEARCH";
export const STOCK_INDEX = "STOCK_INDEX";
export const PNL_DATA_FLAGS = "PNL_DATA_FLAGS";
